export const CONTRACT_ADDRESS = '0x272787Fe24C7F618799F5c15B731b673ada17db9';

export const NETWORK_CONFIG = {
  chainId: '0x2105', // 8453 in hex
  chainName: 'Base',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: ['https://mainnet.base.org'],
  blockExplorerUrls: ['https://basescan.org'],
};

export const IPFS_GATEWAY = 'https://ipfs.io/ipfs/'; 